<template>
  <div class="pcCenter">
    <div class="pageContainer" id="pcCenterMain" v-show="menuList.length != 0">
      <draggable
        v-model="list"
        @update="datadragEndContent"
        :options="{ animation: 500 }"
      >
        <div
          v-for="(item, index) in list"
          :key="item.typeId"
          @click="chooseComponent(item.typeId)"
          class="cp component-div"
          :class="item.typeId == chooseComponentId ? 'active' : ''"
        >
          <component :is="item.component" :info="item" />
          <i
            class="el-icon-delete"
            v-if="item.typeId == chooseComponentId"
            @click="deleteComponent(index)"
          ></i>
        </div>
      </draggable>
    </div>
    <el-empty v-show="menuList.length == 0" description="还没配置导航呢">
      <el-button type="primary" @click="menuSet">去配置</el-button>
    </el-empty>
  </div>
</template>
<script>
import draggable from "vuedraggable";
// header
import header1 from "../template/header/header1/index.vue";
// banner1
import banner1 from "../template/banner/banner1/index.vue";

import banner2 from "../template/banner/banner2/index.vue";
// goods
import goods1 from "../template/goods/goods1/index.vue";
import goods2 from "../template/goods/goods2/index.vue";
//propaganda
import propaganda1 from "../template/propaganda/propaganda1/index.vue";
import propaganda2 from "../template/propaganda/propaganda2/index.vue";
//module
import module1 from "../template/module/module1/index.vue";
import module2 from "../template/module/module2/index.vue";
import module3 from "../template/module/module3/index.vue";
//footer
import footer1 from "../template/footer/footer1/index.vue";
//other
import other1 from "../template/other/other1/index.vue";
import other2 from "../template/other/other2/index.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    draggable,
    header1,
    banner1,
    propaganda1,
    goods1,
    goods2,
    other1,
    banner2,
    propaganda2,
    module1,
    module2,
    module3,
    other2,
    footer1,
  },
  computed: {
    ...mapGetters([
      "menuList",
      "templateList",
      "chooseComponentId",
      "currentIndex",
    ]),
  },
  watch: {
    templateList: {
      handler(val) {
        this.list = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    datadragEndContent(evt) {
      this.$store.commit("design/SET_TEMPLATE", this.list);
      this.$store.commit("design/HAS_CHANGED", true);
      evt.preventDefault();
    },
    chooseComponent(val) {
      this.$store.commit("design/CHOOSE_COMPONENTID", val);
    },
    deleteComponent(index) {
      this.$confirm("是否删除该组件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("design/SET_CURRENTINFO", {});
        this.$store.commit("design/SET_CURRENTINDEX", undefined);
        this.list.splice(index, 1);
        this.$store.commit("design/SET_TEMPLATE", this.list);
        this.$store.commit("design/HAS_CHANGED", true);
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    },
    menuSet() {
      this.$parent.$parent.menuSet();
    },
  },
};
</script>
<style lang="less" scoped>
.pcCenter {
  width: calc(100% - 500px);
  overflow-x: scroll;
  overflow-y: auto;
  background: #f6f7f9;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  // 中间区域css
  .pageContainer {
    padding-bottom: 20px;
    color: #455a64;
    height: 100%;
    width: 1247px;
    .component-div {
      position: relative;
      &:hover {
        border: 2px dashed #266ef6;
      }
    }
    .active {
      border: 2px dashed #f65026 !important;
    }
    .el-icon-delete {
      position: absolute;
      top: 0;
      right: 0;
      background-color: #f65026;
      color: #fff;
      padding: 4px;
      z-index: 999;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/components/pcCenter.vue